const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc, client) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc, client)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc, client) {
        const dest = client.entity === "clientCustomer" ? "clientReceivepayment" : "clientSentpayment";
        this.text = 'View'        //language.start('inProgress')     
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne",  "entity":"${dest}", "dbid": ${detail.dbid} }
           ]}'`

      }
    },

    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail, htmlDt, htmlFc, client) {
        const dest = client.entity === "clientCustomer" ? "clientReceivepayment" : "clientSentpayment";
        const entity = client.entity === "clientCustomer" ? "receivepayment" : "sentpayment";
        const reportName = client.entity === "clientCustomer" ? "receivepayment-one" : "sentpayment-one";
        this.text = 'Print Order'
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"${dest}", "elem":"fullcont", "entity":"${entity}", "reportName":"${reportName}", "act":"pdfMenuFullcont", "dbid": ${detail.dbid} }
        ]}'`

      }

    },

    // {
    //   text: '',
    //   svg: 'print',
    //   class: ``, //same name as the title test

    //   dataDetail: '',

    //   start: function (detail, htmlDt, htmlFc, client) {
    //     const dest = client.entity === "clientCustomer" ? "clientReceivepayment" : "clientSentpayment";
    //     const entity = client.entity === "clientCustomer" ? "receivepayment" : "sentpayment";
    //     console.log(client)
    //     this.text = 'Print'        //language.start('inProgress')
    //     this.dataDetail = `data-detail='{
    //                       "click": [
    //                           {"dest":"ripple" },
    //                           {"dest":"menu", "act":"hide"}, 
    //                           {"dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "entity":"${entity}", "report":"${entity}-one", "act":"reportPdf", "id":"${detail.dbid}"} 

    //     ]}'`

    //   }

    // },
  ],


  // tableOptions: [

  //   {
  //     text: '',
  //     svg: 'print',
  //     class: ``, //same name as the title test

  //     dataDetail: '',


  //     start: function (detail, htmlDt, htmlFc, client) {
  //       this.text = `Account ${client.entity == 'clientCustomer' ? 'Payable' : 'Receivable'}`,        //language.start('inProgress')     
  //         this.dataDetail = `
  //         data-detail='{"click": [
  //           {"dest":"ripple" },
  //           {"dest":"menu", "act":"hide"},
  //           {"dest":"clientPayments", "elem":"report", "reportType":"${client.entity == 'clientCustomer' ? "accountPayable" : "accountReceivable"}"}
  //         ]}'
  //       `
  //     }
  //   },

  // ],

}/*menuBody*/


